<template>
  <div class="w-full max-w-content-xl mx-auto">
    <div class="md:flex items-center justify-between p-5 xl:px-0 pt-5 md:pt-10 pb-5">
      <p class="font-primary font-extrabold text-blue-brand text-28 lg:text-32 -tracking-1/2 mb-5 md:mb-0">Results</p>
      <div class="flex items-center">
        <div class="select-wrapper relative text-blue-dark">
          <select
            name="results-order-by"
            id="results-order-by-select"
            class="h-12.5 w-56 pl-2.5 shadow-tandb md:shadow-landr bg-white text-16 rounded-lg"
            :value="orderBy"
            @change="updateOrderBy"
          >
            <option value="date">Date</option>
            <option value="price">Price</option>
          </select>
        </div>
        <button type="button" class="h-12.5 w-12.5 ml-2 flex items-center justify-center rounded" :class="order === 'ASC' ? '' : 'bg-yellow-brand'" @click.prevent="reverseOrder" title="Reverse order">
          <svg-sprite href="icon-reorder" class="h-5 w-5 text-blue-dark"></svg-sprite>
        </button>
      </div>
    </div>
    <div class="p-2.5 sm:px-5 xl:px-0 sm:py-5 sm:grid grid-cols-2 lg:grid-cols-3 gap-4">
      <div v-for="(adventure, index) in adventures" :key="index" class="w-full h-full mb-2.5 md:mb-0">
        <adventure-preview :adventure="adventure"></adventure-preview>
      </div>
    </div>
  </div>
</template>

<script>
import AdventurePreview from './AdventurePreview';
import SvgSprite from '../vendor/enso/components/SvgSprite.vue';

export default {
  components: { AdventurePreview, SvgSprite },

  props: {
    adventures: {
      type: Array,
      required: true,
    },

    total: {
      type: Number,
      default: 0,
    },

    order: {
      type: String,
      required: true,
    },

    orderBy: {
      type: String,
      required: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    updateOrderBy(e) {
      this.$emit('update-order-by', e.target.value)
    },

    reverseOrder() {
      this.$emit('update-order', this.order === 'ASC' ? 'DESC' : 'ASC');
    }
  }
};
</script>
